module.exports = __webpack_public_path__ + "img/22_59.d48d26d2.png";